import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Billing.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ORDER = ["single_report", "parish_pro", "cathedral"];
const FEATURES = {
  single_report: ["One complete AI report", "PDF export & printing", "Saved permanently to your account"],
  parish_pro: ["Unlimited Parish Intelligence Reports", "Historical comparisons", "Future Liturgical Intelligence™ modules"],
  cathedral: ["Everything in Parish Pro", "Priority Ordo AI™ processing", "Designed for larger parishes & teams"],
};

const CTA_LABEL = { single_report: "Get Started", parish_pro: "Begin Parish Pro", cathedral: "Begin Cathedral Edition" };

function fmt(amount, mode, interval) {
  const dollars = (amount / 100).toLocaleString("en-US", { maximumFractionDigits: 0 });
  return mode === "subscription" ? `$${dollars}/${interval || "mo"}` : `$${dollars}`;
}

export default function PlanCards({ currentPlan, hideCurrent }) {
  const navigate = useNavigate();
  const [plans, setPlans] = useState(null);
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/billing/plans`).then((r) => setPlans(r.data)).catch(() => setPlans({}));
  }, []);

  const startCheckout = async (plan) => {
    setBusy(plan); setError("");
    try {
      const { data } = await axios.post(`${API}/billing/checkout`, { plan, origin: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      setError(e.response?.data?.detail || "Could not start checkout. Please try again.");
      setBusy("");
    }
  };

  if (!plans) return <div className="plan-loading" data-testid="plans-loading">Loading plans…</div>;

  return (
    <div className="plan-wrap">
      {error && <div className="plan-error" data-testid="plan-error">{error}</div>}
      <div className="plan-grid">
        {ORDER.map((key) => {
          const p = plans[key];
          if (!p) return null;
          const isCurrent = currentPlan === key;
          if (hideCurrent && isCurrent) return null;
          const featured = key === "parish_pro" && !(hideCurrent && currentPlan === "parish_pro");
          return (
            <div className={`plan-card${featured ? " featured" : ""}`} key={key} data-testid={`plan-${key}`}>
              {featured && <div className="plan-ribbon">Most Popular</div>}
              <h3>{p.name}</h3>
              <div className="plan-price">{fmt(p.amount, p.mode, p.interval)}</div>
              <p className="plan-blurb">{p.blurb}</p>
              <ul className="plan-features">
                {(FEATURES[key] || []).map((f) => <li key={f}>{f}</li>)}
              </ul>
              <button
                className={`plan-btn${featured ? " gold" : ""}`}
                disabled={busy === key || isCurrent}
                onClick={() => startCheckout(key)}
                data-testid={`checkout-${key}`}>
                {isCurrent ? "Current Plan" : busy === key ? "Redirecting…" : (CTA_LABEL[key] || "Get Started")}
              </button>
            </div>
          );
        })}

        <div className="plan-card diocese" data-testid="plan-diocese">
          <h3>Diocese Edition</h3>
          <div className="plan-price small">Private Pricing</div>
          <p className="plan-blurb">Multi-parish intelligence, diocesan dashboards & dedicated onboarding.</p>
          <ul className="plan-features">
            <li>Everything in Cathedral</li>
            <li>Diocese-wide analytics</li>
            <li>Dedicated support & onboarding</li>
          </ul>
          <button className="plan-btn ghost" onClick={() => navigate("/diocese")} data-testid="diocese-demo-btn">
            Schedule a Conversation
          </button>
        </div>
      </div>
    </div>
  );
}
